export const eventsConstants = {
  EVENTS_INIT: '[Events] init',
  EVENTS_LOADED: '[Events] Loaded',
  EVENTS_FAILED: '[Events] Failed'
}
